import ImageLoader from './ImageLoader.vue';

/* istanbul ignore next */
ImageLoader.install = (Vue) => {
    Vue.component(ImageLoader.name, ImageLoader);
};

export default ImageLoader;
